$(document).ready(function () {
    if ($('.discover').length > 0) {
        function removeBr() {
            $(".discover_card_textLink").find("br").remove();
        }
        if (window.matchMedia("(max-width: 766px)").matches) {
            removeBr();
        }
    }
});
